import { render, staticRenderFns } from "./djDetail.vue?vue&type=template&id=2e61c6e0&scoped=true"
import script from "./djDetail.vue?vue&type=script&lang=js"
export * from "./djDetail.vue?vue&type=script&lang=js"
import style0 from "./djDetail.vue?vue&type=style&index=0&id=2e61c6e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e61c6e0",
  null
  
)

export default component.exports